<template>
    <div>
        <h3 class="text-lg leading-6 font-medium text-gray-900">Contact our sales team</h3>
        <span class="block text-sm leading-normal text-gray-500 mt-2">If you require cover for {{ $attrs.form.vehicle.max + 1 }} or more vehicles
            then call our sales team. Our sales line is open 9am to 5pm, Monday to Friday.</span>

        <a type="button"
           href="tel:03301132433"
           style="-webkit-appearance: none"
           class="block w-full px-5 py-3 border border-transparent text-base font-medium rounded-md text-white bg-green-800 hover:bg-green-900 mt-6">


            <span class="flex items-center justify-center">
                <svg class="-ml-0.5 mr-2 h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                     fill="currentColor">
                    <path
                        d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"/>
                </svg>
                Call {{ phoneNumber }}
            </span>

        </a>
    </div>
</template>

<script>
export default {
    name: "CallUs",
    props: {
        phoneNumber: {
            type: String,
            default: '0330 113 2433',
        },
    },
    mounted(){

    }
}
</script>

<style scoped>

</style>
